module.exports = __webpack_public_path__ + "img/dynamic3.85f10c9c.png";